import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "list", "template", "source"]

  connect() {
    this.render()
  }

  render() {
    const chips = this.checkedOptions().map((checkbox) => {
      const label = checkbox.closest("[data-railsui-dropdown-menu-target='row']")?.dataset.label || checkbox.value
      const chip = this.templateTarget.content.firstElementChild.cloneNode(true)
      const removeButton = chip.querySelector("button")

      removeButton.querySelector("span").textContent = label
      removeButton.setAttribute("aria-label", `Remove ${label} filter`)
      removeButton.dataset.checkboxId = checkbox.id
      return chip
    })

    this.listTarget.replaceChildren(...chips)
    this.containerTarget.hidden = chips.length === 0
  }

  remove(event) {
    const checkbox = document.getElementById(event.currentTarget.dataset.checkboxId)
    const nextChip = event.currentTarget.closest("li")?.nextElementSibling?.querySelector("button")
    const nextCheckboxId = nextChip?.dataset.checkboxId

    if (checkbox) {
      checkbox.checked = false
      checkbox.dispatchEvent(new Event("change", { bubbles: true }))
    }

    const focusTarget = (nextCheckboxId && this.listTarget.querySelector(`[data-checkbox-id="${nextCheckboxId}"]`)) || this.allFiltersButton()
    focusTarget?.focus()
  }

  clearAll() {
    this.sourceTargets
      .filter((source) => source.matches("[data-controller~='railsui-dropdown-menu']"))
      .forEach((source) => {
        this.application.getControllerForElementAndIdentifier(source, "railsui-dropdown-menu")?.clearSelections()
      })
    this.filterPanel()?.clearAll()
    this.render()
    this.allFiltersButton()?.focus()
  }

  checkedOptions() {
    return [...new Set(this.sourceTargets.flatMap((source) =>
      Array.from(source.querySelectorAll("[data-railsui-dropdown-menu-target='checkbox']:checked"))
    ))]
  }

  allFiltersButton() {
    return this.element.querySelector("[data-railsui-filter-panel-target='trigger']")
  }

  filterPanel() {
    const element = this.element.querySelector("[data-controller~='railsui-filter-panel']")
    return element && this.application.getControllerForElementAndIdentifier(element, "railsui-filter-panel")
  }
}
